class restaurantMenuItems extends HTMLElement {
  constructor() {
    super();
    this.isDown = false;
    this.isScrolling = false;
    this.startX = 0;
    this.scrollLeftStart = 0;

    this.mouseDownHandler = this.handleMouseDown.bind(this);
    this.mouseLeaveHandler = this.handleMouseLeave.bind(this);
    this.mouseUpHandler = this.handleMouseUp.bind(this);
    this.mouseMoveHandler = this.handleMouseMove.bind(this);
  }

  connectedCallback() {
    this.addEventListener("mousedown", this.mouseDownHandler);
    this.addEventListener("mouseleave", this.mouseLeaveHandler);
    this.addEventListener("mouseup", this.mouseUpHandler);
    this.addEventListener("mousemove", this.mouseMoveHandler, { passive: true });
  }

  disconnectedCallback() {
    this.removeEventListener("mousedown", this.mouseDownHandler);
    this.removeEventListener("mouseleave", this.mouseLeaveHandler);
    this.removeEventListener("mouseup", this.mouseUpHandler);
    this.removeEventListener("mousemove", this.mouseMoveHandler);
  }

  handleMouseDown(e) {
    this.isDown = true;
    this.isScrolling = false;
    this.startX = e.pageX - this.offsetLeft;
    this.scrollLeftStart = this.scrollLeft;
  }

  handleMouseLeave() {
    this.isDown = false;
    this.isScrolling = false;
    this.classList.remove("is-scrolling");
  }

  handleMouseUp() {
    this.isDown = false;
    this.isScrolling = false;
    this.classList.remove("is-scrolling");
  }

  handleMouseMove(e) {
    if (!this.isDown) return;
    if (!this.isScrolling) {
      this.classList.add("is-scrolling");
      this.isScrolling = true;
    }
    const x = e.pageX - this.offsetLeft;
    const walk = x - this.startX;
    this.scrollLeft = this.scrollLeftStart - walk;
  }
}
if (!customElements.get("restaurant-menu-items")) customElements.define("restaurant-menu-items", restaurantMenuItems);